import React from 'react';
import PropTypes from 'prop-types';
import { Map as IMap } from 'immutable';
import FaceplateImg from '../faceplatePresentation/FaceplateImg';
import { PICKER_CLASS } from '../faceplatePresentation/faceplatePresentationConstants';

export const ProgramPreview = ({
    defaultFaceplate
}) => {
    const faceplateImgProps = {
        cssClass: `${PICKER_CLASS}__image ${PICKER_CLASS}__image--center ${PICKER_CLASS}__image--preview`,
        faceplate: defaultFaceplate
    };
    const showDefaultFaceplate = defaultFaceplate.has('imageURL');

    return showDefaultFaceplate ? <FaceplateImg {...faceplateImgProps} /> : null;
};

ProgramPreview.defaultProps = {
    defaultFaceplate: IMap()
};

ProgramPreview.propTypes = {
    defaultFaceplate: PropTypes.instanceOf(IMap)
};

export default ProgramPreview;
